var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"outlined":_vm.outlined,"color":_vm.color,"label":""}},[_vm._v(_vm._s(_vm._f("etatassociation")(_vm.etat))+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }